/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Blockstatuscompleted2Inputs */

const zh_learn_blockstatuscompleted2 = /** @type {(inputs: Learn_Blockstatuscompleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成`)
};

const en_learn_blockstatuscompleted2 = /** @type {(inputs: Learn_Blockstatuscompleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`completed`)
};

const es_learn_blockstatuscompleted2 = /** @type {(inputs: Learn_Blockstatuscompleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`completado`)
};

/**
* | output |
* | --- |
* | "completed" |
*
* @param {Learn_Blockstatuscompleted2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_blockstatuscompleted2 = /** @type {((inputs?: Learn_Blockstatuscompleted2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Blockstatuscompleted2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_blockstatuscompleted2(inputs)
	if (locale === "en") return en_learn_blockstatuscompleted2(inputs)
	return es_learn_blockstatuscompleted2(inputs)
});
export { learn_blockstatuscompleted2 as "learn_blockStatusCompleted" }